import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CheckboxCheckedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CheckboxChecked",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.13 21.5c-.29 0-.58-.11-.81-.33l-4.99-4.99a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l4.18 4.18 7.91-7.92a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-8.72 8.72c-.22.22-.52.33-.81.33Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27.1 30.86H4.9c-2.07 0-3.76-1.68-3.76-3.76V4.9c0-2.07 1.68-3.75 3.76-3.75h22.2a3.76 3.76 0 0 1 3.76 3.75v22.2c0 2.07-1.68 3.76-3.76 3.76M4.9 3.43c-.81 0-1.47.66-1.47 1.47v22.2c0 .81.66 1.47 1.47 1.47h22.2c.81 0 1.47-.66 1.47-1.47V4.9c0-.81-.66-1.47-1.47-1.47z"
    })]
  }));
};
CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';